
export default {
  props: ['items', 'setVacan', 'setModal'],
};
